import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SchedulerComponent } from './scheduler/scheduler.component';
import { WizardComponent } from './wizard/wizard.component';
import { JobDetailComponent } from './job-detail/job-detail.component';
import { MsalGuard } from '@azure/msal-angular';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ProfileComponent } from './profile/profile.component';
import { TimeCardJobComponent } from './time-card/time-card-job/time-card-job.component';

const appRoutes: Routes = [
  {
    path: '',
    component: TimeCardJobComponent,
    pathMatch: 'full',
    canActivate: [MsalGuard],
  },
  // {
  //   path: 'Scheduler',
  //   component: SchedulerComponent,
  //   canActivate: [MsalGuard],
  // },
  {
    path: 'Wizard',
    component: WizardComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'Wizard/:Id',
    component: WizardComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'job-detail/:Id',
    component: JobDetailComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '401-Unauthorized',
    component: UnauthorizedComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'Profile',
    component: ProfileComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'Review',
    loadChildren: async () =>
      (await import('./review/review.module')).ReviewModule,
    canActivate: [MsalGuard],
  },

  // {
  //   path: 'TimeCard/JobScheduleId/:JobScheduleId/date/:date',
  //   loadChildren: async () => (await import('./time-card/time-card.module')).TimeCardModule,
  //   canActivate: [MsalGuard],
  // },
  {
    path: 'Timecard',
    loadChildren: async () => (await import('./time-card/time-card.module')).TimeCardModule,
    canActivate: [MsalGuard],
  },
  // {
  //   path: '**',
  //   redirectTo: '/401-Unauthorized',
  // },
  // {path:'timecard', loadChildren:async () => (await import ('')).time}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
